// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FileUploader2 from "../../components/molecules/FileUploader2.js";
import * as Buhta_cabinet__Form from "../../core/Form.js";
import * as Buhta_cabinet__Keychain from "../../grpc/Keychain.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__PhoneField from "../../components/html/PhoneField.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ProfileGeneralPage(Props) {
  let profile = Props.profile;
  const match = React.useState(function () {
    return profile.phone;
  });
  const setPhone = match[1];
  const match$1 = React.useState(function () {
    return profile.email;
  });
  const setEmail = match$1[1];
  const match$2 = React.useState(function () {
    return false;
  });
  const setModalPhoto = match$2[1];
  const modalPhoto = match$2[0];
  const match$3 = React.useState(function () {
    return true;
  });
  const setDisabledButton = match$3[1];
  const disabledButton = match$3[0];
  const match$4 = Buhta_core__Tenant.useTenant(undefined);
  const partial_arg = match$4[0];
  const form = Buhta_cabinet__Form.useForm(function (param) {
    return Buhta_cabinet__Keychain.KeyService.create(partial_arg, param);
  });
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
    title: "Общая информация"
  });
  const fileField = Buhta_cabinet__Form.useField(form, undefined, undefined, (function (value) {
    if (Belt__Belt_Option.isSome(value)) {
      return {
        TAG: /* Ok */ 0,
        _0: value
      };
    } else {
      return {
        TAG: /* Error */ 1,
        _0: "выберите файл"
      };
    }
  }));
  const handleUpload = function (file) {
    Curry._1(fileField.onChange, file);
    Curry._1(setDisabledButton, (function (param) {
      return !disabledButton;
    }));
  };
  const modal = JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.P.make, {
                className: "font-semibold",
                children: "Фото профиля"
              }),
              JsxRuntime.jsx("img", {
                className: "cursor-pointer",
                src: StaticAsset.src("/static/icons/close.svg"),
                onClick: (function (param) {
                  Curry._1(setModalPhoto, (function (param) {
                    return !modalPhoto;
                  }));
                })
              })
            ],
            className: "border-b border-gray-main py-4 px-6 flex justify-between items-center gap-x-2"
          }),
          JsxRuntime.jsx(Buhta_cabinet__FileUploader2.make, {
            onChange: handleUpload,
            disabledButton: disabledButton
          })
        ],
        className: "block relative mx-auto top-50 animate-fadeScaleIn duration-200 z-30 w-106 shadow-panel bg-white rounded"
      }),
      className: "fixed top-0 left-0 right-0 bottom-0 z-20 bg-black/70",
      onClick: (function (param) {
        Curry._1(setModalPhoto, (function (param) {
          return false;
        }));
      })
    }),
    className: "flex absolute w-full h-full items-center justify-center"
  });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  profile.userpic_url === "" ? JsxRuntime.jsx("div", {
                      children: profile.first_name.substring(0, 1),
                      className: "w-20 h-20 rounded-full bg-asphalt flex justify-center items-center text-white text-2xl font-semibold"
                    }) : JsxRuntime.jsx("img", {
                      className: "w-20 h-20 rounded-50pct",
                      src: profile.userpic_url
                    }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("img", {
                      src: StaticAsset.src("/static/icons/edit-white-16.svg")
                    }),
                    className: "bg-black/40 absolute bottom-0 w-full cursor-pointer hidden group-hover:flex justify-center py-1",
                    onClick: (function (param) {
                      Curry._1(setModalPhoto, (function (param) {
                        return !modalPhoto;
                      }));
                    })
                  })
                ],
                className: "relative rounded-full w-20 overflow-hidden group"
              }),
              JsxRuntime.jsx(Buhta_components__Text.H1.make, {
                children: profile.first_name + (" " + profile.last_name)
              }),
              modalPhoto ? modal : null
            ],
            className: " flex gap-6 items-center"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
              value: Formating.formatPhone(match[0]),
              onChange: (function (value) {
                Curry._1(setPhone, (function (param) {
                  return value;
                }));
              }),
              label: "Номер телефона"
            }),
            className: "mt-6 relative"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
            label: "Email",
            type_: "email",
            onChange: (function (value) {
              Curry._1(setEmail, (function (param) {
                return value;
              }));
            }),
            autoComplete: "off",
            className: "mt-6",
            value: match$1[0]
          }),
          JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
            title: "Сохранить",
            className: "mt-4 w-full py-3"
          }),
          JsxRuntime.jsx("hr", {
            className: "mt-6"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-6 h-6",
                src: StaticAsset.src("/static/icons/logout.svg")
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
                  children: "Выйти из аккаунта"
                }),
                href: "/logout"
              })
            ],
            className: "flex gap-3 mt-6"
          })
        ],
        className: "bg-white w-140.5 p-10 mt-6 rounded-sm shadow-card"
      }),
      className: "w-full flex flex-col items-center"
    }),
    className: "bg-gray-pale"
  });
}

const make = ProfileGeneralPage;

export {
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
